import React from 'react';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/card'. 'node_modules/@grnhse/seedling/lib/azalea/components/card.js' implicitly has an 'any' type.
import { Card, CardHeader } from '@grnhse/seedling/lib/azalea/components/card';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/tooltips/description_tooltip'. 'node_modules/@grnhse/seedling/lib/azalea/components/tooltips/description_tooltip.js' implicitly has an 'any' type.
import DescriptionTooltip from '@grnhse/seedling/lib/azalea/components/tooltips/description_tooltip';
import { ContentDescription, GdprCardBody } from './components';

import { standardRequest } from 'shared/utils/request';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('gdpr.disclosure.view');

type Props = {
  supportPageUrl: string;
  externalJobApplicationLinksPath: string;
  internalJobApplicationLinksPath: string;
  displayBulkEditLinks: boolean;
};

class DiscloseOnJobPosts extends React.Component<Props> {
  render() {
    return (
      <div>
        <Card useLegacyPadding>
          <CardHeader label={this.headerTitle()} labelSize="large" />
          <GdprCardBody verticalCardGutter="medium">
            <ContentDescription>
              {t('content.description')}
              &nbsp;
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={this.props.supportPageUrl}
              >
                {t('content.learn_more')}
              </a>
              {this.props.displayBulkEditLinks && this.bulkEditLinks()}
            </ContentDescription>
          </GdprCardBody>
        </Card>
      </div>
    );
  }

  headerTitle() {
    return (
      <span>
        {t('header')}
        <DescriptionTooltip text={t('tip')} />
      </span>
    );
  }

  bulkEditLinks() {
    return (
      <div>
        {this.externalLink()} {t('content.conjunction')} {this.internalLink()}
      </div>
    );
  }

  externalLink() {
    return (
      <a href="#" onClick={this.onClickForExternal}>
        {t('content.external_link')}
      </a>
    );
  }

  internalLink() {
    return (
      <a href="#" onClick={this.onClickForInternal}>
        {t('content.internal_link')}
      </a>
    );
  }

  onClickForExternal = () => {
    this.onClick(this.props.externalJobApplicationLinksPath);
  };

  onClickForInternal = () => {
    this.onClick(this.props.internalJobApplicationLinksPath);
  };

  onClick = (url: string) => {
    
    standardRequest.get(url).then((r) => {
      window.location = r.data.url;
    });
  };
}

export default DiscloseOnJobPosts;
